import { AppState } from '../reducers/root';

export const isConnected = (state: AppState): boolean =>
  state.connection.connected;

export const getConnectionId = (state: AppState): string | undefined =>
  state.connection.connectionId;
